import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { UserService, CommonService, DoctorService } from '../../../services/index';

@Component({
	selector: 'add-edit-user-window',
	templateUrl: './addEditUser.component.html'
})
export class AddEditUserComponent implements OnInit {
	public title: string;
	public mode: string;
	//public list: any[] = [];
	public userdata: any[] = [];
	branchList: any[] = [];
    allBranchList: any[] = [];
	// trigger-variable for Ladda
	isLoading: boolean = false;
	branchCtrl: FormControl;
	@Output() userListLoadEvent = new EventEmitter();

	haUserList: any[] = [];
	emplistCtrl: FormControl;
    filteredHaUserList: Observable<any[]>;

	doctorList: any[] = [];
	doctorlistCtrl: FormControl;
    filteredDoctorList: Observable<any[]>;

	constructor(public store: Store<fromRootStore.State>, private userService: UserService, public commonService: CommonService, private doctorService: DoctorService, public bsModalRef: BsModalRef, public toasterService: ToasterService) {
		//FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidBranch(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBranch: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBranch: true };
            }
            return retVal;
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);
		function hasValidEmp(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEmp: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEmp: true };
            }
            return retVal;
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasValidEmp.bind(this)
        ]);

        this.filteredHaUserList = this.emplistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHaUserList(name) : this.haUserList.slice());

		// FOR DOCTOR AUTOCOMPLETE VALIDATION
        this.doctorlistCtrl = new FormControl(null, [
            Validators.required
        ]);

        this.filteredDoctorList = this.doctorlistCtrl.valueChanges
            .startWith(null)
            .map(name => (name && typeof name === 'string') ? this.filterDoctorList(name) : this.doctorList.slice());
	}

	ngOnInit(): void {
		let that = this;
		//TO LOAD BRANCH COMBO
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            that.branchList = _.filter(res.data, function(obj) { return obj['is_crm_branch'] == 'Yes' });
            that.allBranchList = that.branchList;
        });
		this.loadHaUserList();
		this.loadDoctorList();

		setTimeout(() => {
		    $('#username').focus();
		}, 100);
	}

    // FOR FILTER EMPLOYEE LIST
    filterHaUserList(name: string) {
        name = _.escapeRegExp(name);
        return this.haUserList.filter(emp => (new RegExp(name, 'gi').test(emp.empname)));
    }

	// FOR FILTER DOCTOR LIST
    filterDoctorList(name: string) {
        name = _.escapeRegExp(name);
        return this.doctorList.filter(doc => (new RegExp(name, 'gi').test(doc.name)));
    }
    
	onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    displayFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let fitem = _.find(this.branchList, { 'branch_id': branchID });
            return fitem['branch_name'];
        }
        return '';
    }
    displayHaEmp(empid: number) {
		if (empid && this.haUserList.length > 0) {
            let fitem = _.find(this.haUserList, { 'empid': empid });
            return fitem['empname'];
        }
        return '';
    }

	displayDoctor(doctor_id: number) {
		if (doctor_id && this.doctorList.length > 0) {
            let fitem = _.find(this.doctorList, { 'doctor_id': doctor_id });
            return fitem['name'];
        }
        return '';
    }

	loadHaUserList() {
        let that = this,
            data = {
                name: '',
                type: 'challan'
            };
        this.commonService
            .getAvailableEmployeeList(data)
            .then(function (res: any) {
                that.haUserList = res['data'];
                if (that.userdata['empid']) {
                    that.haUserList.unshift({empid: that.userdata['empid'], empname: that.userdata['empname']});
                    that.emplistCtrl.setValue(that.userdata['empid']);
                }
            });
    }

	loadDoctorList() {
        let that = this;
        this.doctorService
            .getDoctorList({})
            .then(function (res: any) {
                that.doctorList = res['data'];
                if (that.userdata['doctor_id']) {
                    that.doctorList.unshift({doctor_id: that.userdata['doctor_id'], name: that.userdata['doctorname']});
                    that.doctorlistCtrl.setValue(that.userdata['doctor_id']);
                }
            });
    }

    onSelectedBranch(status) {
        if (!_.isEmpty(status)) {
            if (status == 'HV') {
                this.branchList = _.filter( this.allBranchList, function(obj) { return obj['is_hv_center'] == 'true' });
            }
            else{
                this.branchList = _.filter( this.allBranchList, function(obj) { return obj['is_hv_center'] == 'false' });
            }
        }
    }

	onSaveUser(): void {
		let that = this;
		//this.isLoading = true;
		this.userService
			.addUpdateUser(this.userdata)
			.then(function(res: any) {
				that.isLoading = false;
				if (res.success){
					swal('SUCCESS', res.message, 'success');
					that.bsModalRef.hide();
					that.userListLoadEvent.emit();
				}else{
					var toast = {
				      type: 'error',
				      title: 'ERROR',
				      body: res.message
				    };
				    that.toasterService.pop(toast);
				}

			});
	}
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/userMaster/addEditUser.component.ts